import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  loadingChild: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 8,
    '& p': {
      color: theme.palette.type === 'dark' ? '#A9E2FA' : '#000',
      margin: 0,
    },
  },
}))

export default useStyles
